var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgParked = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5013 20.1666C5.01507 20.1666 4.54876 19.9734 4.20494 19.6296C3.86112 19.2858 3.66797 18.8195 3.66797 18.3333V3.66659C3.66797 3.18036 3.86112 2.71404 4.20494 2.37023C4.54876 2.02641 5.01507 1.83325 5.5013 1.83325H12.8346C13.1248 1.83278 13.4122 1.88972 13.6803 2.00079C13.9484 2.11186 14.1918 2.27487 14.3966 2.48042L17.6856 5.76942C17.8917 5.9743 18.0552 6.21799 18.1666 6.4864C18.278 6.75482 18.3351 7.04264 18.3346 7.33325V18.3333C18.3346 18.8195 18.1415 19.2858 17.7977 19.6296C17.4538 19.9734 16.9875 20.1666 16.5013 20.1666H5.5013Z",
    stroke: "#57656E",
    strokeWidth: 1.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.832 1.83325V6.41659C12.832 6.6597 12.9286 6.89286 13.1005 7.06477C13.2724 7.23667 13.5056 7.33325 13.7487 7.33325H18.332",
    stroke: "#57656E",
    strokeWidth: 1.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8906 11.9446L9.00154 15.8337",
    stroke: "#57656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9984 11.9446H12.8875V15.8337",
    stroke: "#57656E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgParked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/parked.38257189.svg";
export { ForwardRef as ReactComponent };